/** The version filter; none lets the backend serve the live version. */
export function buildVersionFilters(version: string | undefined) {
  return version
    ? [
        {
          field: "project_publication_id" as const,
          operator: "eq" as const,
          value: version,
        },
      ]
    : [];
}
